import en from '../../lang/en.json';
export const getTranslationFileForLocale = () => en;
